export default "__VITE_ASSET__GW3SowJx__"